__turbopack_context__.v({
  "head": "styles-module__KoIbbG__head",
  "heading": "styles-module__KoIbbG__heading",
  "inner": "styles-module__KoIbbG__inner",
  "note": "styles-module__KoIbbG__note",
  "section": "styles-module__KoIbbG__section",
});
